export default '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" style="max-width: none;">\
  <circle cx="8.5" cy="8.5" r="4.5" fill="var(--color)"/>\
  <path d="M1 8.5C1 12.6421 4.35786 16 8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5Z" stroke="var(--color-secondary)" stroke-miterlimit="10"/>\
</svg>'
